import FeedbackManagement from '@Feedback/views/FeedbackManagement.vue';
import permissions from '@Share/config/permissions';

/**
 * Management-only Feedback screens (AVA-349).
 *
 * The route guard is a convenience, never the security boundary: the API gate is
 * [HasManagementPermission], which is the permission AND a management email
 * domain, so a tenant user holding CompaniesManagement still gets rejected there.
 */
export default [
  {
    path: '/manage-feedback',
    name: 'feedback-management',
    component: FeedbackManagement,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Feedback',
      permissions: [permissions.CompaniesManagement.View],
    },
  },
];
